module.exports = ".sidebar[data-background-color=\"black\"] .sidebar-background:after {\r\n    background: #1270bd;\r\n    opacity: .8;\r\n} "